<miq-text
  [(currentValue)]="value"
  [required]="configuration.required"
  [disabled]="configuration.isDisabled"
  [defaultEmptyValue]="null"
>
</miq-text>
